import { Component, Input, OnInit, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-common-sidebar',
  templateUrl: './common-sidebar.component.html',
  styleUrls: ['./common-sidebar.component.scss']
})
export class CommonSidebarComponent implements OnInit {
  @Input() dynamicContent: TemplateRef<any>;
  openSideBar: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }
}
